import { HStack, Shimmer } from '@betterment/samba-react';

export const FilterRowSkeleton: React.FC = () => {
  return (
    <HStack
      css={{
        gap: 'space.400',
      }}
    >
      <Shimmer
        css={{
          height: 'size.600',
          borderRadius: 'radius.100',
        }}
      />
      <Shimmer
        css={{
          height: 'size.600',
          borderRadius: 'radius.100',
        }}
      />
      <Shimmer
        css={{
          height: 'size.600',
          borderRadius: 'radius.100',
        }}
      />
    </HStack>
  );
};
